import { CheckOutlined, CopyOutlined, LoadingOutlined } from '@ant-design/icons'
import { Collapse, message, Spin, Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { fetchUserBets, verifyToken } from '../components/socket'
const params = new URLSearchParams(window.location.search);
const allParams = {};
for (const [key, value] of params?.entries()) {
allParams[key] = value;

}

export default function BetRecords() {
    const [currentBetRecodPage,setCurrentBetPage] = useState(1)
    const [currencySymbol,setCurrencySymbol]= useState("INR");
    const [userToken,setUserToken] = useState(null)
    const [siteLoading,setSiteLoading] = useState(false);
    const [showAlert,setShowAlert]= useState(false)
    const [alertMessage,setAlertMessage] = useState("")
    const [betRecords,setBetRecords] = useState([]);
    const [totalBetRecordPages,setTotalBetRecordsPages] = useState(1);
    const [betRecordPageSize,setbetRecordPageSize] = useState(10);
    const [userId,setUserId] = useState(null);
    const [currentIssue,setcurrentIssue] = useState(1);

    useEffect(()=>{
        if(allParams?.token && allParams?.user){
            verifyToken(allParams.token).then(response => { if (response.status) setCurrencySymbol(response.data.currency || 'INR'); });
            setUserToken(allParams?.token)
            setUserId(allParams?.user)
        }else{
            setSiteLoading(false)
        }
    },[allParams,params])


        useEffect(()=>{
            if(userId && currentBetRecodPage &&userToken){
                _fetchUserBetRecords("issue"+currentIssue);
            }
        },[userId,currentBetRecodPage,userToken])
    
        const _fetchUserBetRecords= async(isssue="issue1")=>{
            setSiteLoading(true)
            let response = await fetchUserBets(userId,currentBetRecodPage,userToken,isssue);
            if(response?.status){
                setBetRecords(response?.data);
                setTotalBetRecordsPages(response?.pagination?.totalPages || 1)
                setbetRecordPageSize(response?.pagination?.limit || 10)
            }
            else{
                setBetRecords([])
                setTotalBetRecordsPages(1)
                setbetRecordPageSize(10)
                message.error("Something went wrong!")
            }
            setSiteLoading(false)
        }

    const _copyText=(text)=>{
        navigator.clipboard.writeText(text).then(() => {
          setAlertMessage("Copy successful")
          setShowAlert(true)
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
    }
    
    const items = betRecords?.length>0 && betRecords.map((item,index)=>
        (
             {
                key: item?._id || index,
                label: <div key={item?._id || index} className="detailsHeader">
                            <div className="dshLeft">
                                <div className=
                                {`dshLeftNumber ${item?.betValue===0?"multiColor":item?.betValue===5?"multiColorNew":item?.betValue%2===0?"red":item?.betValue%2===1?"green":item?.betValue}`}
                                >
                                    {
                                        item?.betType==="bigSmall" ?
                                        <span style={{color:"#fff"}}>{item.betValue}</span>
                                        :
                                        item?.betType==="straight"?
                                        item?.betValue
                                        :""
                                    }
                                </div>
                                <div>
                                    <p>{item?.order}</p>
                                    <span>{moment(item?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
                                </div>
                            </div>
                                {
                                    item?.status!=="pending"?
                                        <div className={`dshRight `}>
                                            <span className={item?.win ? "green":"red"}>{item?.win ? "Succeed":"Failed"}</span>
                                            <p className={item?.win ? "green":"red"}>{item?.win?"+ ":"- "}{currencySymbol +" "}{item?.win?parseFloat(item?.winAmount).toFixed(2):Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</p>
                                        </div>
                                    :null
                                }
                        </div>,
                children: 
                <div key={index} className="detailsBody">
                    <h4>Details</h4>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Order number</span>
                        </div>
                        <div className="dblRight" >
                            <span >{item?.order} </span>
                            <span><CopyOutlined style={{color:"#768096"}} onClick={()=>_copyText(item?.order)}/></span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Period</span>
                        </div>
                        <div className="dblRight">
                            <span>{moment(item?.createdAt).format('YYYYMMDDHHmmssSSS')} </span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Purchase amount</span>
                        </div>
                        <div className="dblRight">
                            <span>{currencySymbol+" "}{Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft"><span>Platform Fee ({item?.platformFeePercentage ?? 0}%)</span></div>
                        <div className="dblRight"><span>{currencySymbol+" "}{Number(item?.platformFeeAmount ?? 0).toFixed(2)}</span></div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft"><span>Bet amount</span></div>
                        <div className="dblRight"><span>{currencySymbol+" "}{Number(item?.betAmount).toFixed(2)}</span></div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Select</span>
                        </div>
                        <div className="dblRight">
                            <span style={{textTransform:"capitalize"}}>{item?.betValue}</span>
                        </div>
                    </div>
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Amount after tax</span>
                        </div>
                        <div className="dblRight">
                            <span className={item?.win ? "green":"red"}>{currencySymbol}--</span>
                        </div>
                    </div> */}
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Tax</span>
                        </div>
                        <div className="dblRight">
                            <span>{currencySymbol}--</span>
                        </div>
                    </div> */}
                      <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span >Result</span>
                        </div>
                        <div className="dblRight result">
                            {
                                item?.status!=="pending"?
                                <>
                                    <span style={{textTransform:"capitalize"}}>{item?.result}</span>
                                    <span className={item?.result===1||item?.result===5?"violet":item?.result%2===0?"red":item?.result%2===1?"green":item?.result}>
                                        {item?.result===1||item?.result===5?"Violet":item?.result%2===0?"Red":item?.result%2===1?"Green":item?.result}
                                    </span>
                                    <span className={item?.result>=5?"orange":"blue"}>{item?.result>=5?"Big":"Small"}</span>
                                </>
                                :<span>--</span>
                            }
                        </div>
                    </div>
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Select</span>
                        </div>
                        <div className="dblRight">
                            <span>--</span>
                        </div>
                    </div> */}
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Status</span>
                        </div>
                        <div className="dblRight">
                            {
                                item?.status!=="pending"?
                                <span className={item?.win ? "green":"red"}>{item?.win ? "Succeed":"Failed"}</span>
                                :<span>Pending</span>
                            }
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Win/Lose</span>
                        </div>
                        <div className="dblRight">
                            {
                                item?.status!=="pending" ?
                                <span className={item?.win ? "green":"red"}>{item?.win?"+ ":"- "}{currencySymbol+" "}{item?.win ? parseFloat(item?.winAmount).toFixed(2) :Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</span>
                                :<span>--</span>

                            }
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Order Time</span>
                        </div>
                        <div className="dblRight">
                            <span>{moment(item?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
                        </div>
                    </div>
    
                </div>,
            }
        )
        ) 

    const getCurrencySymbol = (currencyCode) => {
        const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currencyCode
        });
        const formatted = formatter.format(1);
        return formatted.replace(/[0-9,.]/g, '').trim();
    };

    const _prevRecordPage = ()=>{
        if(currentBetRecodPage>1){
            setCurrentBetPage((prev)=>--prev)
        }
    }
    const _nextRecordPage = ()=>{
        if(currentBetRecodPage<totalBetRecordPages){
            setCurrentBetPage((prev)=>++prev)
        }
    }
    const _changeTabs = (e) =>{
        setcurrentIssue(e)
        setCurrentBetPage(1)
        if(userId && currentBetRecodPage &&userToken){
            
            _fetchUserBetRecords("issue"+e);
        }
    }

  return (
    <div className="betRecords Wingo_game customAccordion">
        <div className="stickyHeader flex align-items-center">
        <div className="shLeft">
          <Link to={`/${window.location.search}`}>
            <img
              src="/assets/images/left-arrow-svgrepo-com.svg"
              alt=""
              style={{ width: "25px" }}
            />
          </Link>
        </div>
        <div className="shCenter">
          <span>Win Go</span>
        </div>
      </div>
      <div className="betRecordsBody">
        <Tabs defaultActiveKey="1" onChange={_changeTabs}>
            <TabPane tab="WinGo 30s" key="1">
                {
                    siteLoading? <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:100}}>
                         <Spin indicator={<LoadingOutlined spin />} />
                    </div>
                    :
                    items?.length>0?
                    <>
                        <Collapse items={items} expandIcon={() => null} />
                        <div className="pagination">
                    <button className={`previousButton ${currentBetRecodPage>1? "active" :""}`} onClick={_prevRecordPage} > 
                        <svg
                            fill={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                    </button>
                    <span style={{fontSize:"13px",color:"#768096"}}>{currentBetRecodPage}/{totalBetRecordPages}</span>
                    <button className={`nextButton ${currentBetRecodPage<totalBetRecordPages ? "active" :""}`} onClick={_nextRecordPage}>                           
                        <svg
                            fill={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                            transform="rotate(180)"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                        </button>
                </div>
                    </>
                    :<div style={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:"100px",
                        justifyItems:"center",
                        color:"#768096",
                        fontSize:"16px",
                        }}>
                        No data
                    </div>
                }
             
            </TabPane>
            <TabPane tab="WinGo 1Min" key="2">
            {
                    siteLoading? <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:100}}>
                         <Spin indicator={<LoadingOutlined spin />} />
                    </div>
                    :
                    items?.length>0?
                    <>
                        <Collapse items={items} expandIcon={() => null} />
                        <div className="pagination">
                    <button className={`previousButton ${currentBetRecodPage>1? "active" :""}`} onClick={_prevRecordPage} > 
                        <svg
                            fill={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                    </button>
                    <span style={{fontSize:"13px",color:"#768096"}}>{currentBetRecodPage}/{totalBetRecordPages}</span>
                    <button className={`nextButton ${currentBetRecodPage<totalBetRecordPages ? "active" :""}`} onClick={_nextRecordPage}>                           
                        <svg
                            fill={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                            transform="rotate(180)"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                        </button>
                </div>
                    </>
                    :<div style={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:"100px",
                        justifyItems:"center",
                        color:"#768096",
                        fontSize:"16px",
                        }}>
                        No data
                    </div>
                }
               
            </TabPane>
            <TabPane tab="WinGo 3Min" key="3">
            {
                    siteLoading? <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:100}}>
                         <Spin indicator={<LoadingOutlined spin />} />
                    </div>
                    :
                    items?.length>0?
                    <>
                        <Collapse items={items} expandIcon={() => null} />
                        <div className="pagination">
                    <button className={`previousButton ${currentBetRecodPage>1? "active" :""}`} onClick={_prevRecordPage} > 
                        <svg
                            fill={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                    </button>
                    <span style={{fontSize:"13px",color:"#768096"}}>{currentBetRecodPage}/{totalBetRecordPages}</span>
                    <button className={`nextButton ${currentBetRecodPage<totalBetRecordPages ? "active" :""}`} onClick={_nextRecordPage}>                           
                        <svg
                            fill={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                            transform="rotate(180)"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                        </button>
                </div>
                    </>
                    :<div style={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:"100px",
                        justifyItems:"center",
                        color:"#768096",
                        fontSize:"16px",
                        }}>
                        No data
                    </div>
                }
                
            </TabPane>
            <TabPane tab="WinGo 5Min" key="4">
            {
                    siteLoading? <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:100}}>
                         <Spin indicator={<LoadingOutlined spin />} />
                    </div>
                    :
                    items?.length>0?
                    <>
                        <Collapse items={items} expandIcon={() => null} />
                        <div className="pagination">
                    <button className={`previousButton ${currentBetRecodPage>1? "active" :""}`} onClick={_prevRecordPage} > 
                        <svg
                            fill={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage>1 ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                    </button>
                    <span style={{fontSize:"13px",color:"#768096"}}>{currentBetRecodPage}/{totalBetRecordPages}</span>
                    <button className={`nextButton ${currentBetRecodPage<totalBetRecordPages ? "active" :""}`} onClick={_nextRecordPage}>                           
                        <svg
                            fill={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            stroke={currentBetRecodPage<totalBetRecordPages ? "#fff" : "#7682a2"}
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="22px"
                            viewBox="0 0 100.00 100.00"
                            enableBackground="new 0 0 100 100"
                            xmlSpace="preserve"
                            strokeWidth="3.5"
                            transform="rotate(180)"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                            <g>
                                <path
                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                />
                            </g>
                            </g>
                        </svg>
                        </button>
                </div>
                    </>
                    :<div style={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:"100px",
                        justifyItems:"center",
                        color:"#768096",
                        fontSize:"16px",
                        }}>
                        No data
                    </div>
                }
                
               
            </TabPane>
        </Tabs>
      </div>
      {
        showAlert?
         <ShowAlert alertMessage={alertMessage} setShowAlert={setShowAlert} />
         :null
      }
    </div>
  )
}

const ShowAlert =({alertMessage,setShowAlert})=>{
    useEffect(()=>{
        setTimeout(() => {
            setShowAlert(false)
        }, 2000);
    },[])
    return(
            alertMessage==="Copy successful"?
            <div className="siteLoading showAlertMessage copyAlert">
                <span><CheckOutlined style={{color:"#fff",fontSize:"30px"}} /></span>
                <p>Copy successful</p>
            </div>
            :
            <div className="siteLoading showAlertMessage">
                <p>{alertMessage || "Refresh Successfully"}</p>
            </div>
    )
}
